import type { PropsWithChildren } from 'react'

import Box from '@mui/material/Box'

import { useAuthenticatedUser } from '../../auth/hooks/useAuthenticatedUser'
import { Navigation } from '../../nav'
import { LoginNavigation } from '../../nav/components/LoginNavigation'

export { Layout }

const Layout = ({ children }: PropsWithChildren) => {
  const { hasPermissions } = useAuthenticatedUser()

  return (
    <>
      {hasPermissions ? <Navigation /> : <LoginNavigation />}

      <Box
        component="main"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1,
        }}
      >
        {children}
      </Box>
    </>
  )
}
